import React, {Dispatch, SetStateAction} from "react"
type Options = {
    title?: string;
    value?:string
    subTitle?: string;
    imageSrc?: string;
}[]
type QuizzContextProviderState = {
    appendQuizAnswers: (answers: string[] | number[][], quizzName: string) => void
    setActiveQuizz: Dispatch<SetStateAction<number>>
    activeQuizz: number
    quizzData: Record<string, string[] | number[][]>
    parentCategories: any
    updateUserQuizzChoices: ()=>Promise<void>
    totalNumberOfProducts: number | null
    isLoadingProductsCount: boolean
    parseQuizData: (quizzData: Record<string, string[] | number[][]>) => { [x: string]: string; }
    brandsList:Options
    brandsToShow:Options
    setBrandsToShow:Dispatch<SetStateAction<Options>>
}

export const QuizzContext = React.createContext<QuizzContextProviderState>({
	appendQuizAnswers: null,
	setActiveQuizz: () => null,
	activeQuizz: null,
	quizzData: {},
	updateUserQuizzChoices: null,
	parentCategories: null,
	totalNumberOfProducts: null,
	isLoadingProductsCount: false,
	parseQuizData: null,
	brandsList: null,
	brandsToShow: null,
	setBrandsToShow: () => null

})
